import React from 'react';
import PropTypes from 'prop-types';
import { BarLoader } from 'react-css-loaders';
import Table from './Table';
import Card from './Card';


const scheduleAPI = process.env.REACT_APP_SCHEDULE;

class ScheduleContainer extends React.Component {
  state = {
    data: undefined,
    weekNr: 0,
    isLoading: false,
    resourceTimeStep: undefined,
    activeParticipants: undefined,
    activeProduct: undefined,
    masterDate: undefined,
    pickerDate: new Date(),
  };

  componentDidMount() {
    this.setState({
      data: this.props.items,
      resourceTimeStep: this.props.items.timeStep,
      activeParticipants: this.props.activeParticipants,
    });

    if (this.props.masterData !== undefined) {
      this.setState(
        {
          masterDate: this.props.masterData.date.date,
        },
        () => this.getScheduleData(false),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    // Disable update update if its not needed?

    if (nextProps.masterData !== undefined) {
      if (this.state.masterDate !== nextProps.masterData.date.date) {
        this.setState(
          {
            masterDate: nextProps.masterData.date.date,
          },
          () => this.getScheduleData(false),
        );
      }
    }
    /*
    if (this.props.refreshSchedule === false || nextProps.refreshSchedule === false) {
      return;
    }

    */


    if (this.props.activeParticipants !== nextProps.activeParticipants) {
      // save participants to state so we can run this function before render.
      // todo set something in backend to disable this if we dont need it.
      this.setState(
        {
          activeParticipants: nextProps.activeParticipants,
        },
        () => {
          if (nextProps.items.updateOnParticipantChange === true) {
            this.getScheduleData(false);
          }
        },
      );
    }

    if (this.props.activeProduct !== nextProps.activeProduct) {
      // save participants to state so we can run this function before render.
      this.setState(
        {
          activeProduct: nextProps.activeProduct,
        },
        () => {
          if (nextProps.items.updateOnProductChange === true) {
            this.getScheduleData(true);
          }
        },
      );
    }
    // todo: Only run one of these if both are true we run both
  }


  resetChosenDates = () => {
    const { onClickSchedule } = this.props;

    onClickSchedule(undefined);
  };

  getScheduleData = (reset = true, date = false) => {
    this.setState({ isLoading: true });
    if (reset) {
      this.resetChosenDates();
    }


    const hashid = this.props.id;

    let week = `?week=${this.state.weekNr}`;

    if (date) {
      const m = this.state.pickerDate;
      const isoDate = new Date(m.getTime() - (m.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
      const dateString = isoDate;

      week = `?date=${dateString}`;
    }


    const participants = `&participants=${this.state.activeParticipants}`;

    // This is only required if spoton is enabled in backend
    // const sku = `&sku=${this.props.product}`;

    let sku = '';

    if (this.state.activeProduct !== undefined) {
      sku = `&sku=${this.state.activeProduct}`;
    }

    let getAll = week + participants + sku;


    const masterData = this.props.masterData !== undefined;

    let onlyThisDate = '';

    if (masterData) {
      onlyThisDate = this.state.masterDate;

      getAll = `?date=${onlyThisDate}&onlythisdate=1`;
    }


    fetch(scheduleAPI + hashid + getAll)
      .then(response => response.json())
      .then(data => this.setState({ data, weekNr: data.week, isLoading: false }));

    // remove selected timeslot on change
    // this.props.onDateChange(null);
  };


  handleButton = (direction) => {
    const getWeekNr = this.state.weekNr;
    let weekNr;
    if (direction === '+') {
      weekNr = +getWeekNr + 1;
    } else if (direction === '-') {
      weekNr = +getWeekNr - 1;
      if (weekNr <= 0) {
        weekNr = 0;
      }
    }

    this.setState({ weekNr }, () => this.getScheduleData(false));
    const node = this.divElement;
    node.scrollIntoView();
  };

  pickerOnChange = pickerDate => this.setState({ pickerDate }, () => {
    if (this.state.pickerDate === null) {
      this.setState({ pickerDate: new Date() }, () => this.getScheduleData(false, true));
      return;
    }
    this.getScheduleData(false, true);
  });


  render() {
    const {
      data, resourceTimeStep, isLoading, pickerDate,
    } = this.state;


    const {
      onClickSchedule, activeDate, activeProduct, duration, lang, masterData, bookingData, id,
    } = this.props;
    if (data === undefined) return null;

    if (isLoading) {
      return (
        <div
          ref={(divElement) => { this.divElement = divElement; }}
          id="scheduleHolder"
        >
          <Card title={lang.loading}>
            <BarLoader />

          </Card>
        </div>

      );
    }
    console.log('masterdata',masterData);
    console.log(bookingData);
    return (


      <div
        ref={(divElement) => { this.divElement = divElement; }}
        id="scheduleHolder"
      >
        <Table
          title={lang.topic}
          button={this.handleButton}
          items={data}
          lang={lang}
          timeStep={resourceTimeStep}
          onClickSchedule={onClickSchedule}
          activeDate={activeDate}
          activeProduct={activeProduct}
          duration={duration}
          pickerDate={pickerDate}
          pickerOnChange={this.pickerOnChange}
          masterData={masterData}
          bookingData={bookingData}
          productId={id}
        >
          <div>Children
          </div>
        </Table>
      </div>

    );
  }
}

ScheduleContainer.defaultProps = {
  activeProduct: undefined,
};

ScheduleContainer.propTypes = {
  items: PropTypes.object.isRequired,
  activeDate: PropTypes.objectOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
  })).isRequired,
  activeProduct: PropTypes.number,
  onClickSchedule: PropTypes.func.isRequired,
  refreshSchedule: PropTypes.bool.isRequired,
};


export default ScheduleContainer;



// WEBPACK FOOTER //
// ./src/components/Resource/components/ScheduleContainer.jsx